import { render, staticRenderFns } from "./testItemManager.vue?vue&type=template&id=a8db5a66&scoped=true"
import script from "./testItemManager.vue?vue&type=script&lang=js"
export * from "./testItemManager.vue?vue&type=script&lang=js"
import style0 from "./testItemManager.vue?vue&type=style&index=0&id=a8db5a66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8db5a66",
  null
  
)

export default component.exports